import $ from 'jquery';



/* Site Menu
********************************************/

$('.js-offcanvas-menu-dropdown-toggle').on('click', function (e) {
	e.preventDefault();
	$(this).siblings('.c-site-menu__dropdown').slideToggle();
	$(this).closest('.has-children').toggleClass('is-active');
});
